export default {
  SET_PROMOTER_ID(state, payload) {
    state.promoter_id = payload;
  },
  SET_PROMOTER_NAME(state, payload) {
    state.promoter_name = payload;
  },
};
